export default __webpack_public_path__ + "static/pspo2-01-674abb9d45b56f9dd91556083f267208.png";